(function () {
  /*
   * The dedicated ritual-upgrade module (ss-bundle-upsell.liquid) for
   * Prickly Pear Seed Oil and Argan Oil renders both size-specific
   * cards up front (30ml/15ml or 100ml/50ml). Each card's
   * data-show-for lists which selected variant value(s) it should be
   * visible for (comma-separated). This listens for the customer
   * changing the size radio/select and toggles visibility to match --
   * no page reload, no re-fetching content, just showing/hiding the
   * blocks that are already there.
   */
  function syncUpsell(container, value) {
    container.querySelectorAll('[data-show-for]').forEach(function (block) {
      var values = block.dataset.showFor.split(',');
      block.hidden = values.indexOf(value) === -1;
    });
  }

  function handleChange(event) {
    var target = event.target;
    if (!target || (target.tagName !== 'INPUT' && target.tagName !== 'SELECT')) return;
    if (!target.closest('variant-selects')) return;

    var value = target.value;
    document.querySelectorAll('[data-variant-upsell]').forEach(function (container) {
      syncUpsell(container, value);
    });
  }

  document.addEventListener('change', handleChange);
})();
